import styled from 'styled-components'

const InputFile = styled.input `
    display: none;
`

export default InputFile;
